import React from 'react'
import styles from './TourWidget.module.css'

const defaultState = {
  currentStepIndex: 0,

  current: {
    image: {
      center: [0,0],
      zoom: 1,
    },
    mask: null,
    tooltip: null,
  },

  introVisible: true,
  summaryVisible: false,
  layersVisible: true,
  tooltipVisible: true,
  singleStep: false,
}

export default Component => {
  return class extends React.Component {
    state = this.props.data ? {...this.props.data.state} : {...defaultState}
    steps = []
    intro = null
    summary = null

    get isFirstStep() {
      return this.state.currentStepIndex === 0
    }
    get isLastStep() {
      return this.summary
        ? this.state.currentStepIndex === this.steps.length && this.summary
        : this.state.currentStepIndex === this.steps.length - 1
    }
    get progressValue() {

      return Math.round((this.state.currentStepIndex + 1) / this.steps.length * 100)
    }

    init = data => {
      this.steps = data.steps
      this.intro = data.intro
      this.summary = data.summary

      this.autoStart()
      this.forceUpdate()
    }

    animateToStart = () => {
      this.setState({ current: defaultState.current })
    }
    animateToStep = () => {
      this.setState({ current: this.steps[this.state.currentStepIndex] })
    }

    autoStart = () => {
      if(this.intro) return
      this.startTour()
    }
    startTour = () => {
      this.setState({ introVisible: false }, this.animateToStep)
    }
    restartTour = () => {
      this.setState({
        ...defaultState,
      }, this.autoStart)
    }
    finishTour = () => {
      this.props.onUpdate({ state: this.state })
      this.props.onSubmit(this.state)
    }

    prevStep = () => {
      this.setState(state => {
        const step = state.currentStepIndex - 1
        const currentStepIndex = step < 0 ? this.steps.length-1 : step

        return { currentStepIndex, singleStep: false }
      }, this.animateToStep)
    }
    nextStep = () => {
      this.setState(state => {
        const nextStep = state.currentStepIndex + 1
        const isLastStep = nextStep === this.steps.length
        const currentStepIndex = isLastStep ? 0 : nextStep

        return { currentStepIndex, summaryVisible: isLastStep && this.summary ? true : false, singleStep: false }
      }, () => {
        if(this.state.summaryVisible) {
          this.animateToStart()
        } else {
          this.animateToStep()
        }
      })
    }
    goToStep = (step) => {
      this.setState(state => {
        return { currentStepIndex: step, singleStep: true }
      }, () => {
        // this.toggleLayers()
        this.animateToStep()
      })
    }
    toggleLayers = () => {
      this.setState(state => ({
        layersVisible: state.layersVisible
          ? false
          : state.singleStep
            ? false
            : true,
        singleStep: false
      }))
    }

    handleStart = e => {
      this.startTour()
    }
    handleRestart = e => {
      this.restartTour()
    }
    handleFinish = e => {
      this.finishTour()
    }
    handlePrevStep = e => {
      this.prevStep()
    }
    handleNextStep = e => {
      this.nextStep()
    }
    handlePrevStep = e => {
      this.prevStep()
    }
    handleGoToStep = (step) => {
      this.goToStep(step)
    }
    handleLayers = e => {
      if(this.state.layersVisible || this.state.singleStep) {
        this.animateToStart()
      } else {
        this.animateToStep()
      }

      this.toggleLayers()
    }

    render() {
      return <Component {...this.props} tour={{
        state: this.state,
        steps: this.steps,
        intro: this.intro,
        summary: this.summary,
        init: this.init,
        isFirstStep: this.isFirstStep,
        isLastStep: this.isLastStep,
        progressValue: this.progressValue,
        handleStart: this.handleStart,
        handleRestart: this.handleRestart,
        handleFinish: this.handleFinish,
        handlePrevStep: this.handlePrevStep,
        handleNextStep: this.handleNextStep,
        handleGoToStep: this.handleGoToStep,
        handleLayers: this.handleLayers,
      }} />
    }
  }
}
